/**
 * model representing an Organization
 */
export interface Organization {
  organizationId?: number;

  name?: string;

  // the following fields are sourced from the organization's latest GOBS
  summary?: string;
  city?: string;
  state?: string;
  country?: string;

  // date that the organization was created in Smart Response
  addedDate?: string | number | Date;

  // URI of the organization's logo image
  logoURI?: string;

  // when the organization is approved, they will be filled, otherwise they are null
  givingPortalUrl?: string;
  merchantId?: string;

  // Text for sharing on Facebook and Twitter
  metadata?: string;

  ofacLastCheckedDate?: string | Date | null;

  // helper property for row-selection state in the OFAC check bulk-select column
  ofacCheckSelected?: boolean;
}
